export const medicalActions = {
    SAVE_SELECT_BTN: "SAVE_SELECT_BTN"
}

export const educationActions = {
    SAVE_TEACHER: "SAVE_TEACHER"
}

export const authAction = {
    SAVE_USER: "SAVE_USER",
    REMOVE_USER: "REMOVE_USER",
    SAVE_USER_OWNED_DATA: "SAVE_USER_OWNED_DATA"
}